<template>
  <div :class="_.coupon">
    <div :class="_.hd"></div>
    <div :class="_.bd">
      <div
        v-for="(item, index) in curData"
        :key="item.id"
        :class="[
          _.item,
          item.extendData.status === 1 && _.ok,
          item.extendData.status === 2 && _.over,
        ]"
      >
        <div :class="_.price">{{ +item.amt }}</div>
        <div :class="_.desc">
          {{ item.subTitle }}
        </div>
        <div
          v-track="{
            name: '领券',
            id: `${componentId}-receive`,
            resource: item,
            index: index,
          }"
          :class="_.button"
          @click="handleCouponReceiveClick(item.id)"
        />
      </div>
    </div>
    <div :class="_.ft"></div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Toast } from 'vant'
  import { wait } from 'vtils'

  export default Vue.extend({
    data() {
      return {
        curData: this.data,
      }
    },

    computed: {
      allStatus() {
        return this.curData.some(item => item.extendData.status === 0)
          ? 'available'
          : this.curData.some(item => item.extendData.status === 1)
          ? 'ok'
          : 'over'
      },
    },

    methods: {
      async refreshCouponData() {
        this.curData = (
          await this.$dmbcApi.getComponentData({
            id: this.componentId,
            pageIndex: 1,
            pageSize: 100,
            useCdn: this.pageTheme.cdn,
          })
        ).list
      },

      async handleCouponReceiveClick(couponId) {
        const loading = Toast.loading({
          message: '领取中...',
          duration: 0,
        })
        try {
          await this.$dmbcApi.receiveCoupon({
            couponActId: couponId,
          })
          await wait(2000)
          await this.refreshCouponData()
          loading.close()
          Toast.success('领取成功')
        } catch {
          loading.close()
        }
      },

      async handleCouponAllReceiveClick() {
        const loading = Toast.loading({
          message: '领取中...',
          duration: 0,
        })
        try {
          await Promise.all(
            this.curData
              .filter(item => item.extendData.status === 0)
              .map(item =>
                this.$dmbcApi.receiveCoupon({
                  couponActId: item.id,
                }),
              ),
          )
          await wait(2000)
          await this.refreshCouponData()
          loading.close()
          Toast.success('领取成功')
        } catch {
          loading.close()
        }
      },

      handleCouponCenterClick() {
        window.dcb.openCouponCenter()
      },
    },
  })
</script>

<style lang="scss" module="_">
  .coupon {
    font-size: 0;
  }

  .hd {
    width: 100%;
    height: 75.43px;
    background-image: url('./images/背景_上.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }

  .bd {
    background-image: url('./images/背景_中.png');
    background-size: 100% auto;
    background-repeat: repeat-y;
    background-position: 0 0;
    display: flex;
    flex-wrap: wrap;
    padding: 0 18px;

    .item {
      width: 33.333%;
      height: 137px;
      background-image: url('./images/框_小.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      .price {
        position: relative;
        font-size: 38px;
        color: #ffffff;
        line-height: 53px;
        color: #87b0d5;
        white-space: nowrap;

        &::after {
          content: '';
          position: absolute;
          top: 10px;
          right: -4px;
          width: 12px;
          height: 12px;
          background-image: url('./images/钱.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      .desc {
        font-size: 12px;
        color: #666666;
        line-height: 16px;
        padding: 0 8px;
        text-align: center;
      }

      .button {
        margin-top: 7px;
        width: 72px;
        height: 20px;
        background-image: url('./images/立即领取.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
      }

      &:nth-child(1),
      &:nth-child(2) {
        width: 50%;
        height: 131px;
        background-image: url('./images/框_大.png');

        .price {
          font-size: 50px;
          line-height: 60px;

          &::after {
            top: 12px;
          }
        }
      }

      &.ok {
        .button {
          pointer-events: none;
          background-image: url('./images/已领取.png');
        }
      }

      &.over {
        .button {
          pointer-events: none;
          background-image: url('./images/已抢完.png');
        }
      }
    }
  }

  .ft {
    width: 100%;
    height: 17px;
    background-image: url('./images/背景_下.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>
